import { PButtonPure } from '@porsche-design-system/components-react';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import breakpoints from '../../../utilities/breakpoints';

const Footer = styled.div`
    max-width: 75vw;
    z-index: 10;
    inset-inline-start: clamp(16px, 1.25vw + 12px, 36px);
    bottom: clamp(16px, 1vw, 52px);
    position: absolute;
    transition: transform 0.3s ease-in-out;
`;

const ButtonWrapper = styled.div`
    display: flex;
    position: absolute;
    top: 25%;
    bottom: 0;
    inset-inline-end: 0px;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    box-shadow: 0px 0px 4px #0000001a;
    background-color: #eeeff2;
    width: 54px;
    height: 54px;
    transform: translate(50%);

    @media (max-width: ${breakpoints.sm}) {
        top: 0;
        inset-inline-end: 0px;
        top: 50%;
        transform: translate(0, -50%);
    }
`;

type Props = { children: React.ReactNode };

const LightBoxFooter = ({ children }: Props) => {
    const [isExpand, setIsExpand] = useState(true);

    useEffect(() => {
        setIsExpand(false);
    }, []);

    return (
        <Footer style={{ transform: `translateX(${isExpand ? '0%' : '-98%'})` }}>
            {children}
            <ButtonWrapper>
                <PButtonPure
                    icon={isExpand ? 'arrow-left' : 'arrow-right'}
                    onClick={() => setIsExpand(!isExpand)}
                    type="button"
                    hideLabel
                />
            </ButtonWrapper>
        </Footer>
    );
};

export default LightBoxFooter;
